import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { AbstractControl, UntypedFormArray } from '@angular/forms';
import { Fields } from '../../car-details.component';

@Component({
  selector: 'app-summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SummaryComponent {
  @Input() cars: AbstractControl;
  @Output() removeCar: EventEmitter<number> = new EventEmitter<number>();
  @Output() addNewCar: EventEmitter<any> = new EventEmitter<any>();

  carDetailsVisible = [true, true, true];

  readonly maxCarsAllowed = 3;
  readonly fields = Fields;

  toggleCarDetails(index: number) {
    this.carDetailsVisible[index] = !this.carDetailsVisible[index];
  }

  remove(index: number) {
    this.removeCar.emit(index);
  }

  getCarModelName(index: number, carModel: string): string {
    if (carModel === 'notInTheList') {
      return (this.cars as UntypedFormArray).at(index).get(Fields.additionalCarModel).value;
    } else {
      return carModel;
    }
  }

  addNew(): void {
    this.addNewCar.emit();
  }

  addNewButtonVisible(): boolean {
    return (this.cars as UntypedFormArray).length < this.maxCarsAllowed;
  }
}
